import { Injectable } from '@angular/core';
import {
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { SystemService } from 'common/services/core-services/system.service';
import { AlumniModel } from 'common/models/page-models/Alumni-form/alumni-form-data-model';
import { AlumniFormDataService } from 'common/services/data-services/admin/alumni/alumni-form-data.service';
import { AlumniMetaModel } from 'common/models/page-models/Alumni-form/alumni-form-meta-model';
import { ConsentDataService } from 'common/services/data-services/custom-service/consent.service';

@Injectable({
  providedIn: 'root',
})
export class AlumniFormWidgetService extends FormWidgetService<AlumniModel> {

  constructor(
    public ds: AlumniFormDataService,
    private ss: SystemService,
    protected consentService: ConsentDataService
  ) {
    super(ds);
  }

  override prepareMetaModel(dataModel: AlumniModel, metaModel: AlumniMetaModel, routeData: WidgetModel): Promise<AlumniMetaModel> {
    return new Promise<AlumniMetaModel>((resolve, reject) => {
      //   this.branchListService.postData('').then((data) => {
      //     metaModel.properties['branch_id'].options = data.detail;
      // })
      // metaModel.properties['state_name'].options = this.ss.dataStorage.state_List;
      // metaModel.properties['region'].options = this.ss.dataStorage.zone_name;

        this.consentService.postData('').then((data) => {
          metaModel.properties['consent'] = data.details;
      })

      resolve(metaModel);
    });
  }

  Save(body: any, url: string) {
    this.ds.postLoginData(body, url).then((response) => {
      if (response.header.type === 'success') {
        this.ss.showSuccess(response.header.msg);
      }

    });
  }

  getMetaModel(): MetaModel {
    const meta = new AlumniMetaModel();
    return meta.getMetaModel();
  }

}
